import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import breakpointsMinWidth from '../../../../../../../cra/src/styling/breakpointsMinWidth';
import getFormattedDateblog from '../../../../utils/getFormattedDateblog';

const HeaderWrap = styled.header`
  & a,
  & a:hover {
    color: unset;
    text-decoration: none;
  }
  .carousel.carousel-slider {
    position: sticky;
  }
`;

const BlogWrap = styled.div`
  background: url(${(props) => props.bgIMG});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: calc(100vh - 200px);
`;

const Overlay = styled.div`
  position: relative;
  text-align: left;
  height: calc(100vh - 200px);
  align-items: center;
  justify-content: center;
  /* min-height: calc(100vh - 58px); */

  color: #fff;
  background-color: rgba(0, 0, 0, 0.4);

  padding: 60px 32px;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 12px;

  @media ${breakpointsMinWidth.tabletSm} {
    padding: 48px 0;

    /* min-height: calc(48vh - 58px); */

    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 24px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    padding: 80px 0;

    /* min-height: calc(46vh - 58px); */

    grid-template-columns: repeat(12, 1fr);
  }

  @media ${breakpointsMinWidth.tabletLg} {
    padding: 100px 0;

    /* min-height: calc(72vh - 58px); */
  }

  @media ${breakpointsMinWidth.desktopMd} {
    /* min-height: calc(58vh - 58px); */
  }
`;

const Content = styled.div`
  grid-column: 1/-1;
  margin-top: -50px;

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 2/-3;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: 2/-5;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    grid-column: 2/-6;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    grid-column: 2/-7;
  }

  @media ${breakpointsMinWidth.desktopLg} {
    grid-column: 3/-6;
  }
`;

const Heading = styled.h5`
  line-height: 32px;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 24px;
    line-height: 36px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    font-size: 28px;
    line-height: 40px;

    margin: 0 0 16px 0;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 36px;
    line-height: 48px;
  }

  /* @media ${breakpointsMinWidth.desktopSm} {
    font-size: 44px;
    line-height: 60px;

    margin: 0 0 24px 0;
  } */

  /* @media ${breakpointsMinWidth.desktopMd} {
    font-size: 48px;
    line-height: 64px;
  } */
`;

const Summary = styled.p`
  color: #f1f1f1;

  font-size: 12px;
  line-height: 20px;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 14px;
    line-height: 24px;

    margin: 0 0 24px 0;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 16px;
    line-height: 28px;

    margin: 0 0 32px 0;
  }
`;

const Chip = styled.span`
  padding: 8px 16px;

  background-color: rgba(255, 255, 255, 0.4);

  border-radius: 4px;

  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const AuthorWrap = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 14px;

  margin: 60px 0 0 0;

  @media ${breakpointsMinWidth.tabletSm} {
    margin: 48px 0 0 0;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    margin: 60px 0 0 0;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    margin: 80px 0 0 0;
  }
`;

const Image = styled.img`
  width: 100%;
`;

const AuthorPicture = styled(Image)`
  border-radius: 50%;

  width: 36px !important;
  height: 36px !important;
`;

const AuthorInfo = styled.div``;

const Name = styled.div`
  color: #fff;

  font-weight: 500;
`;

const TimePost = styled.div`
  color: #f1f1f1;

  font-size: 12px;
`;

const Header = ({ blog: blogData }) => {
  return (
    <HeaderWrap>
      <Carousel showThumbs={false} showStatus={false} infiniteLoop>
        {blogData.slice(0, 5).map((blog) => {
          const formattedDate = getFormattedDateblog(blog.created);
          return (
            <Link key={blog.id} to={blog.blogUrl}>
              <BlogWrap bgIMG={blog.blogImg && blog.blogImg.url}>
                <Overlay>
                  <Content>
                    <Heading>{blog.title}</Heading>
                    <Summary>{blog.summary}</Summary>
                    <Chip>{blog.categoryName}</Chip>

                    <AuthorWrap>
                      <AuthorPicture
                        src={blog.profileIMG && blog.profileIMG.url}
                        alt={blog.author}
                      />
                      <AuthorInfo>
                        <Name>{blog.author}</Name>
                        <TimePost>
                          {formattedDate} • {blog.readTime} min read
                        </TimePost>
                      </AuthorInfo>
                    </AuthorWrap>
                  </Content>
                </Overlay>
              </BlogWrap>
            </Link>
          );
        })}
      </Carousel>
    </HeaderWrap>
  );
};

export default Header;
